export const TITLE = "Kubermax";
export const DESCRIPTION = "DESCRIPTION";

// Branch / LSP (Kubermax) details
export const ADDRESS =
  "Circular Road, Bhatti gate, Jhajjar, Haryana- 124103";
export const BRANCH_ADDRESS =
  "Circular Road, Bhatti Gate, Jhajjar, Haryana-124103";
export const EMAIL = "support@kubermax.in";
export const INFO_EMAIL = "info@kubermax.in";
export const PHONE = "+919254064756";
export const WHATSAPP_PHONE = "+919742946919";
// Customer support mobile
export const SUPPORT_PHONE = "+919254064756";

// LSP (Kubermax) grievance officers
export const LSP_GRO_NAME = "Mr. Azad";
export const LSP_GRO_EMAIL = "grievances@kubermax.in";
export const LSP_GRO_PHONE = "+91 7404755563";
export const LSP_NODAL_NAME = "Mr. Manjeet Singh";
export const LSP_NODAL_EMAIL = "grievance.nodal@kubermax.in";
export const LSP_NODAL_PHONE = "+91 9742946919";

// NBFC (lender) details — V.N. Credits Limited
export const NBFC_NAME = "V.N. Credits Limited";
export const NBFC_ADDRESS =
  "3/2, Amar Park, Zakhira, New Rohtak Road, New Delhi, Delhi, India - 110045";
export const NBFC_PHONE = "+91 9311227994";
export const NBFC_WEBSITE = "https://www.vncredits.in";
export const NBFC_COR = "B-14.01330";
export const NBFC_CIN = "U65929DL1997PLC085203";
export const NBFC_GRO_NAME = "Sakshi Jinsi";
export const NBFC_GRO_EMAIL = "grievance@vncredits.in";
export const NBFC_NODAL_NAME = "Amit Kumar";
export const NBFC_NODAL_EMAIL = "nodal@vncredits.in";
